import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Login from './pages/login';
import ForgetPassword from './pages/forget-password';
import SignUp from './pages/sign-up';
import PrivateRoute from './routers/private-router';
import Landing from './pages/landing';
import Marketing from './pages/marketing';
import Home from './pages/home';
import NotFound from './pages/not-found';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import PrivacyPolicy from './pages/privacy-policy';
import TermsAndConditions from './pages/terms-and-conditions';
import ContactUs from './pages/contact-us';

function App() {


  // new Lenis({
  //   autoRaf: true,
  // });



  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Landing />} />
          <Route path='/marketing' element={<Marketing />} />
          <Route path='/login' element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path='/home' element={<Home />} />
          </Route>
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <Toaster position='bottom-right' />
    </>
  )
}

export default App;
